import { isNonNullable } from '@/typeguards/common'
import { FROM_PROFILE_INDEX_PAGE_QUERY_PARAMETER } from './constants'

export const isFromProfileIndexPage = () => {
  const queryParameters = new URLSearchParams(window.location.search)

  return isNonNullable(queryParameters.get(FROM_PROFILE_INDEX_PAGE_QUERY_PARAMETER))
}
